import React from 'react'
import styles from '../AdminPanelPage.module.scss'

// Форма создания водителя для ТЭЦ — аналог CreateDriverForm (top_base -> chpp)
const CreateChppDriverForm = ({ employees = [], employeeSearch = '', setEmployeeSearch = () => {}, modalPayload = {}, setModalPayload = () => {}, closeModal = () => {}, createDriver, loadDriversByChpp = async () => {}, notifySuccess = () => {}, notifyError = () => {}, uploadDriverDocuments }) => {
  const [selectedFiles, setSelectedFiles] = React.useState([])
  const fileInputRef = React.useRef(null)
  
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || [])
    setSelectedFiles(prevFiles => [...prevFiles, ...files])
    if (fileInputRef.current) fileInputRef.current.value = ''
  }
  
  const removeFile = (index) => {
    setSelectedFiles(prevFiles => prevFiles.filter((_, i) => i !== index))
  }
  
  const handleCreate = async () => {
    try {
      const payload = { ...modalPayload }
      if (modalPayload.chpp_name) delete payload.chpp_name
      
      const response = await createDriver(payload)
      const driverId = response?.data?.id
      
      if (selectedFiles.length > 0 && driverId) {
        try {
          await uploadDriverDocuments(driverId, selectedFiles)
        } catch (docErr) {
          console.error('Failed to upload documents:', docErr)
          notifyError(docErr, 'Водитель создан, но не удалось загрузить документы')
        }
      }
      
      if (payload.chpp) await loadDriversByChpp(payload.chpp)
      closeModal()
      notifySuccess('Водитель создан')
    } catch (err) {
      console.error(err)
      notifyError(err, 'Не удалось создать водителя')
    }
  }
  
  return (
    <>
      <label>Сотрудник</label>
      <input
        placeholder="Поиск сотрудника..."
        value={employeeSearch}
        onChange={(e) => setEmployeeSearch(e.target.value)}
      />
      <select value={modalPayload.employee || ''} onChange={(e) => setModalPayload(p => ({ ...p, employee: Number(e.target.value) }))}>
        <option value="">— Выберите сотрудника —</option>
        {employees.filter(emp => (emp.label || '').toLowerCase().includes(employeeSearch.toLowerCase())).map(emp => (
          <option key={emp.id} value={emp.id}>{emp.label}</option>
        ))}
      </select>

      <label>ТЭЦ</label>
      <input placeholder="ТЭЦ" value={modalPayload.chpp_name || modalPayload.chpp || ''} readOnly />

      <label>Номер автомобиля</label>
      <input placeholder="Номер машины" value={modalPayload.vehicle_number || ''} onChange={(e) => setModalPayload(p => ({ ...p, vehicle_number: e.target.value }))} />

      <label>Модель автомобиля</label>
      <input placeholder="Модель машины" value={modalPayload.vehicle_model || ''} onChange={(e) => setModalPayload(p => ({ ...p, vehicle_model: e.target.value }))} />
      
      <label>Документы</label>
      <input 
        ref={fileInputRef}
        type="file" 
        multiple 
        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
        onChange={handleFileChange}
      />
      {selectedFiles.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <strong>Выбранные файлы:</strong>
          <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
            {selectedFiles.map((file, index) => (
              <li key={index}>
                {file.name} ({(file.size / 1024).toFixed(1)} KB)
                <button 
                  type="button"
                  onClick={() => removeFile(index)}
                  style={{ marginLeft: 8, color: 'red', cursor: 'pointer', background: 'none', border: 'none' }}
                >
                  ✕
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
      
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => { closeModal() }} className={styles.btn_pin_close}>Отмена</button>
        <button onClick={handleCreate} className={styles.btn_pin}>Создать</button>
      </div>
    </>
  )
}

export default CreateChppDriverForm
